export default __webpack_public_path__ + "static/tk-ec24e65ed9d23987d1227f92fbd20bce.svg";